import React, { lazy, Suspense } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import LoadingOverlay from 'react-loading-overlay'
import FadeLoader from 'react-spinners/FadeLoader'

// Lazy pages
const KitchenDisplayList = lazy(() => import('../Pages/KitchenDisplayList'))
const AddKitchenDisplay = lazy(() => import('../Pages/AddKitchenDisplay'))
const EditKitchenDisplay = lazy(() => import('../Pages/EditKitchenDisplay'))
const ViewKitchenDisplay = lazy(() => import('../Pages/ViewKitchenDisplay'))

LoadingOverlay.propTypes = undefined

function Loading() {
  return (
    <>
      <div className='wrapperContainer'>
        <div className='loader-body'>
          <LoadingOverlay
            active={true}
            spinner={<FadeLoader color={'#ccc !important'} size={50} />}
            styles={{
              overlay: (base) => ({ ...base, background: 'transparent' })
            }}
          >
            <div style={{ height: '100px' }} />
          </LoadingOverlay>
        </div>
      </div>
    </>
  )
}

function KitchenDisplayRoute() {
  const history = useHistory()

  return (
    <Switch>
      <Route
        exact
        path='/:lng/restaurant/kitchen-display'
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <KitchenDisplayList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/list'
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <KitchenDisplayList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/add'
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <AddKitchenDisplay history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/edit/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <EditKitchenDisplay {...props} history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      <Route
        exact
        path='/:lng/restaurant/kitchen-display/view/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <ViewKitchenDisplay {...props} history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default KitchenDisplayRoute
